interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "XCD";
};

const XCD: Currency = Object.freeze({
  "displayName": "East Caribbean Dollar",
  "numericCode": 951,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "XCD",
  "symbol": "$"
});

export { XCD };
